

























































































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import Colorable from '@/mixins/colorable';
import VueDraggable from 'vuedraggable';

import {
  Operand,
  OperandType,
  Operator,
  Operation
} from '@/models/configurator/question';
import { isNil } from 'lodash';

export default mixins(Proxyable, Colorable).extend({
  components: {
    VueDraggable
  },

  props: {
    itemRequired: {
      type: Boolean,
      default: false
    },

    moduleId: {
      type: [Number, String],
      default: null
    }
  },

  data: () => ({
    showNote: false,
    showComputation: false,
    noOperator: 'N/A',
    Operation
  }),

  computed: {
    operandListEnableCheck() {
      return this.internalValue.operands
        .map((operand: any) => {
          if (operand.type == OperandType.VARIABLE) {
            return operand.question;
          } else if (operand.type == OperandType.CONSTANT) {
            return operand.constant;
          } else if (operand.type == OperandType.NONE) {
            return 0; // LF-2021-04-17 - This is a hack and this function to be improved
          }
        })
        .every((value?: number) => {
          return !isNil(value);
        });
    },

    newOperandEnabled(): boolean {
      switch (this.internalValue.operation) {
        case Operation.ASSIGN:
          if (!this.internalValue.operands.length) {
            return this.operandListEnableCheck;
          }
          return false;

        case Operation.COMPUTE:
        default:
          return this.operandListEnableCheck;
      }
    }
  },

  mounted() {
    // incase the data is in a bad state adjust operand order so it can be re-ordered
    this.updateOperandOrder();
  },

  methods: {
    addOperand() {
      this.internalValue.operands.push(
        new Operand({
          module: Number(this.moduleId),
          type: OperandType.VARIABLE,
          order: this.internalValue.operands.length + 1
        })
      );

      if (this.internalValue.operands.length > 1) {
        this.internalValue.operators.push(
          new Operator({
            symbol: '*'
          })
        );
      }
    },

    removeOperand(index: number) {
      this.internalValue.operands.splice(index, 1);

      // check if there is operator to delete
      if (this.internalValue.operators.length > 0) {
        // if operand index is 0, then delete the first operator
        const operatorIndex = index > 0 ? index - 1 : 0;
        this.internalValue.operators.splice(operatorIndex, 1);
      }

      // updating order as the removed operand index can be from anywhere
      this.updateOperandOrder();
    },

    operandUpdated() {
      this.$emit('operandUpdated');
    },

    updateOperandOrder() {
      (this.internalValue.operands as Operand[]).forEach((operand, index) => {
        operand.order = index + 1;
        return operand;
      });

      this.operandUpdated();
    }
  }
});
